import styled, { css } from 'styled-components';
import { gridConfig as breakpoints } from '../../fuse-responsive-grid/src/grid';

const animatedGradient = css`
	background: linear-gradient(
		-45deg,
		var(--color-global-grey400),
		var(--color-global-grey300),
		var(--color-global-grey400),
		var(--color-global-grey500)
	);
	background-size: 400% 400%;
	animation: gradient 4s ease infinite;

	@keyframes gradient {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
`;

export const SkeletonCard = styled.div.attrs({
	className: 'fuse-complex-product-card__skeleton',
	'data-testid': 'fuse-complex-product-card__skeleton',
})`
	display: inline-flex;
	position: relative;
	flex-direction: column;
	width: 100%;
	min-width: 0;
`;

export const SkeletonImg = styled.div.attrs({
	className: 'fuse-complex-product-card-skeleton__image',
	'data-testid': 'fuse-complex-product-card-skeleton__image',
})`
	width: 100%;
	aspect-ratio: 3 /4;
	// safari doesn't support aspect-ratio before version 15
	@supports not (aspect-ratio: 3 / 4) {
		padding-top: calc(4 / 3 * 100%);
	}
	margin: 0 0 var(--spacing-global-space4);
	${animatedGradient}
`;

export const SkeletonBrand = styled.div.attrs({
	className: 'fuse-complex-product-card-skeleton__brand',
	'data-testid': 'fuse-complex-product-card-skeleton__brand',
})`
	width: 78px;
	height: var(--font-line-height-m1); /*line-height*/
	${animatedGradient}
	margin: 0 0 var(--spacing-global-space2);
`;

export const SkeletonTitle = styled.div.attrs({
	className: 'fuse-complex-product-card-skeleton__title',
	'data-testid': 'fuse-complex-product-card-skeleton__title',
})`
	margin: 0 0 var(--spacing-global-space2);

	&::before,
	&::after {
		content: '';
		display: block;
		height: var(--font-line-height-m1);
		${animatedGradient}
	}
	&:before {
		width: 100%;
		margin: 0 0 1px;
	}
	&:after {
		width: 100%;
	}

	@media only screen and (min-width: ${breakpoints.l.minWidth}) {
		&:before {
			width: 65%;
		}
		&:after {
			width: 32%;
		}
	}
`;

export const SkeletonPrice = styled.div.attrs({
	className: 'fuse-complex-product-card-skeleton__price',
	'data-testid': 'fuse-complex-product-card-skeleton__price',
})`
	height: 24px;
	width: 88px;
	${animatedGradient}
`;
